import { Reveal } from "./Reveal";
import { SERVICES } from "../data/content";
import { useLang } from "../i18n/LanguageContext";

export const Services = () => {
  const { t } = useLang();

  return (
    <section
      id="servizi"
      data-testid="services-section"
      className="scroll-mt-20 py-24 md:py-32 bg-[#0A0A0C]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <span className="block text-xs uppercase tracking-[0.3em] text-[#C5A059] mb-4">
            {t.services.overline}
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white max-w-2xl">
            {t.services.title}
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-12 auto-rows-[230px] gap-4 md:gap-6">
          {SERVICES.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.08} className={`${s.span} min-h-[230px]`}>
              <article
                data-testid="service-card"
                className="group relative h-full w-full overflow-hidden border border-[#C5A059]/20 hover:border-[#C5A059]/50 transition-colors"
              >
                <img
                  src={s.img}
                  alt={t.services.items[i].title}
                  className="absolute inset-0 w-full h-full object-cover grayscale opacity-50 transition-all duration-700 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
                <div className="relative h-full flex flex-col justify-end p-7">
                  <h3 className="font-serif text-2xl text-white">{t.services.items[i].title}</h3>
                  <p className="mt-2 text-sm text-zinc-300 font-light max-w-md opacity-0 translate-y-3 transition-all duration-500 group-hover:opacity-100 group-hover:translate-y-0">
                    {t.services.items[i].desc}
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
